import { ManagementPage } from "../components/common/ManagementPage";

const driverFields = [
  { name: "first_name", label: "First name", required: true, placeholder: "Amy" },
  { name: "last_name", label: "Last name", required: true, placeholder: "Hayes" },
  { name: "phone", label: "Phone", required: true, placeholder: "403-555-0201" },
  { name: "email", label: "Email", placeholder: "amy.hayes@example.com", type: "email" },
  { name: "license_number", label: "License number", required: true, placeholder: "A12345678" },
  { name: "license_expiry", label: "License expiry", type: "date" },
  {
    name: "status",
    label: "Status",
    required: true,
    type: "select",
    options: [
      { label: "Active", value: "Active" },
      { label: "Inactive", value: "Inactive" },
    ],
  },
  { name: "notes", label: "Notes", type: "textarea", placeholder: "Availability or dispatch notes" },
];

export const DriversPage = () => (
  <ManagementPage
    actionLabel="Add driver"
    columns={[
      {
        key: "full_name",
        label: "Driver",
        render: (item) => item.full_name,
      },
      { key: "phone", label: "Phone" },
      { key: "email", label: "Email" },
      { key: "license_number", label: "License #" },
      { key: "license_expiry", label: "Expiry" },
      { key: "status", label: "Status" },
    ]}
    description="Manage internal driver records with the few details dispatchers need every day: name, phone, license, and status."
    endpoint="/drivers"
    entityName="Driver"
    fields={driverFields}
    title="Drivers"
  />
);